<template>
  <div>
    <PageHeader title="Questions"></PageHeader>
    <div v-if="!start && entry && !answered">
      <h3>You have {{totalTimeAllowed/60}} minutes to answer {{entry.totalQuestions}} questions</h3>
      <div class="mt-4">When you ready, click the "Start" button below.</div>
      <div class="mt-4">
        <v-btn outlined large block 
        color="fanhiveHoney"
        @click="startQuestions(entry)"
        style="color: #ffffff !important;border: 1px solid #ffb300;"
        >Start</v-btn>
      </div>
    </div>
    <div v-if="start && !answered">
      <div class="mb-3" style="color:#ffb300;font-weight:bold;">Time remaining: {{rem}}</div>
      <div v-if="entry && questions && questions.length">
        <h3>{{questions[currentQuestionIndex].name}}</h3>
        <v-radio-group 
          v-model="answer"
        >
          <v-radio
            v-for="questionAnswer in questions[currentQuestionIndex].answers"
            :key="questionAnswer.questionAnswerId"
            :label="questionAnswer.name"
            :value="questionAnswer.questionAnswerId"
          ></v-radio>
        </v-radio-group>
      </div>
      <div class="mt-4">
        <v-btn outlined large block 
        color="fanhiveHoney"
        @click="answerSelected(answer)"
        :disabled="!readyNext"
        style="color: #ffffff !important;border: 1px solid #ffb300;"
        >{{nextButtonText}}</v-btn>
      </div>
    </div>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      centered
      color="success"
      id="snackbarLogin"
    >
      Your transaction was approved and you can now answer the question(s).
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <Spinner :overlay="overlay"></Spinner>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import _ from 'lodash';
import axios from 'axios';
import Socket from "./../../plugins/socket";
import Spinner from './../../components/Spinner';

export default {
  name: 'questions',
  components: {
    PageHeader,
    Spinner
  },
  data: () => ({
    overlay: false,
    totalTimeAllowed: 0,
    entry: null,
    start: false,
    answered: false,
    rem: "03:00",
    timeUp: false,
    questions: null,
    currentQuestionIndex: 0,
    answer: null,
    answers: null,
    timerIntervalPersisted: null,
    nextButtonText: 'Next',
    timerInterval: null,
    snackbar: false
  }),
  computed: {
    allAnswered () {
      return this.answers && this.answers.length === this.questions.length;
    },
    readyNext () {
      return this.answer !== null;
    }
  },
  methods: {
    reconnect: function () {
      var scope = this;
      console.log('Connectionid is null when submitting answers, must get new one.');
      Socket.connect(scope.$store.getters.userSub.userName);
      setTimeout(() => {
        scope.submitAnswers();
      }, 2500);
    },
    getEntry: function () {
      var scope = this;
      this.overlay = true;
      this.$store.dispatch('getEntry', this.$route.query.entryId).then(getEntryResponse => {
        scope.entry = getEntryResponse;
        this.$store.dispatch('getQuestions', {
          sportId: scope.$route.query.sportId,
          totalQuestions: scope.$route.query.totalQuestions
        }).then(getQuestionsResponse => {
          var qs = [];
          var qNum = 0;
          getQuestionsResponse.forEach(question => {
            var answers = [];
            qNum = qNum + 1;
            var qAnswers = JSON.parse(question.extraData).questionAnswers;
            scope.shuffleArray(qAnswers);
            qAnswers.forEach(answer => {
              answers.push({ questionAnswerId: answer.questionAnswerId, name: answer.name, isCorrect: answer.isCorrect })
            });
            qs.push({ id: question.id, name: question.name, answers: answers, questionNumber: qNum });
          });
          scope.questions = qs;
          this.overlay = false;
          if(scope.entry.totalRetry >= 2) {
            scope.submitAnswers();
          }
        }, error => {
            console.log(error);
        });
      }, error => {
          console.log(error);
      });
    },
    shuffleArray: function (array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },
    startQuestions: function () {
      var scope = this;
      this.start = true;
      scope.updateRetry();
      var secRemaining = this.totalTimeAllowed;
      scope.timerInterval = setInterval(() => {
        secRemaining = secRemaining - 1;
        var minRem = Math.floor(secRemaining/60);
        var secRem = secRemaining%60;
        this.rem = (`${String(minRem).padStart(2, '0')}:${String(secRem).padStart(2, '0')}`);
        if (secRemaining < 1) {
          clearInterval(scope.timerInterval);
          scope.timeUp = true;
          if (scope.$route.query.retry === undefined || scope.$route.query.retry < 1) {
            var retry = scope.$route.query.retry;
            if(retry === undefined)
              retry = 0;
            scope.$router.push({name: 'questions-times-up', query: {entryId: scope.entry.id, retry: retry, sportId: scope.$route.query.sportId, totalQuestions: scope.$route.query.totalQuestions}});
          } else {
            scope.submitAnswers();
          }
        }
      }, 1000);
      scope.timerIntervalPersisted = scope.timerInterval;
    },
    updateRetry: function () {
      var scope = this;
      var retryCount = (scope.entry.totalRetry === null ? 0 : scope.entry.totalRetry) + 1;
      axios.put(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entries/${scope.$route.query.entryId}`, {
          totalRetry: retryCount
        },{
            headers: {
              Authorization: localStorage.getItem('jwtToken')
            }
          })
            .then(function () {
              console.log('Entry total retry updated to: ' + retryCount);
            })
            .catch(function (error) {
              console.log(error);
            });
    },
    answerSelected: function (questionAnswerId) {
      console.log('Answer: ' + questionAnswerId);
      var scope = this;
      var selectedAnswer = _.find(scope.questions[scope.currentQuestionIndex].answers, (o) => {
        return o.questionAnswerId === questionAnswerId;
      });
      if (scope.answers === null) {
        var firstLocalAnswers = [
          {
            questionId: scope.questions[scope.currentQuestionIndex].id,
            answerId: questionAnswerId,
            isCorrect: selectedAnswer.isCorrect,
            questionNumber: scope.questions[scope.currentQuestionIndex].questionNumber
          }];
        scope.answers = firstLocalAnswers;
      } else {
        var localAnswers = _.clone(scope.answers);
        localAnswers.push({
          questionId: scope.questions[scope.currentQuestionIndex].id,
          answerId: questionAnswerId,
          isCorrect: selectedAnswer.isCorrect,
          questionNumber: scope.questions[scope.currentQuestionIndex].questionNumber
        });
        scope.answers = localAnswers;
      }
      if (scope.currentQuestionIndex < scope.questions.length - 1) {
        scope.currentQuestionIndex = scope.currentQuestionIndex + 1;
      } else {
        clearInterval(scope.timerIntervalPersisted);
      }
      scope.answer = null;
    },
    submitAnswers: function () {
      this.overlay = true;
      var promises = [];
      var correctAnswers = 0;
      var scope = this;

      if(scope.$store.getters.connectionId === null){
        scope.reconnect();
        return;
      }

      scope.questions.forEach(theQuestion => {
        var questionAnswer = {
          entryId: scope.$route.query.entryId,
          userId: scope.$store.getters.userSub.id,
          questionId: theQuestion.id
        };
        var theAnswer = _.find(scope.answers, (o) => {
          return o.questionId === theQuestion.id;
        });
        if(theAnswer !== undefined){
          questionAnswer.questionAnswerId = theAnswer.answerId;
          questionAnswer.questionNumber = theAnswer.questionNumber;
          if(theAnswer.isCorrect) {
            correctAnswers++;
          }
        }
        promises.push(axios.post('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entry-question-answers', questionAnswer, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        }));
      });
      Promise.all(promises).then(() => {
        scope.$store.commit('setUpdatingEntry', 1);
        axios.put(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entries/${scope.$route.query.entryId}`, {
          answered: true,
          correctAnswers: correctAnswers
        },{
            headers: {
              Authorization: localStorage.getItem('jwtToken'),
              connectionid: scope.$store.getters.connectionId
            }
          })
            .then(function () {
              //honey points now added after competition is resulted
              scope.overlay = false;
              scope.$router.push({name: 'entry-home', query: {entryId: scope.entry.id, answered: 1}});
            })
            .catch(function (error) {
              console.log(error);
            });
      })
    }
  },
  created () {
    console.log(this.$route.query.paymentApproved);
    if(this.$route.query.paymentNotRequired !== 'yes'){
      if(this.$route.query.paymentApproved) {
        this.snackbar = true;
      }
    }
    this.getEntry();
  },
  beforeDestroy() {
    if(this.timerInterval !== null){
      clearTimeout(this.timerInterval);
    }
  },
  watch: {
    allAnswered (newVal) {
      if(newVal){
        this.submitAnswers();
      }
    },
    questions (newVal){
      if(Array.isArray(newVal)){
        this.totalTimeAllowed = newVal.length * 60;
      }
    }
  }
}
</script>